import React from 'react';
import { components } from 'react-select';

import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';

import { iaRa } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

export const SortValueLabel = ({ innerProps, ...props }) => {
  return (
    <components.MultiValueLabel
      {...props}
      innerProps={{ ...innerProps, className: `${innerProps.className} flex gap-1` }}>
      <Icon icon="drag-drop-linear" size={12} className="text-primary-600" />
      {props.data.label}
    </components.MultiValueLabel>
  );
};

export const SortSelectValues = (props) => {
  const { children, selectProps } = props;
  const selected = selectProps.value || [];

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(selected);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    selectProps?.onChange?.(reordered);
  };

  const selectedOptions = iaRa(children?.[0]);

  return (
    <components.ValueContainer {...props}>
      <div className={`flex w-full ${selectedOptions.length ? 'items-end' : 'items-center'}`}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="selected-values">
            {(provided) => {
              return (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <div className="flex flex-col">
                    {selectedOptions.map((option, index) => (
                      <Draggable key={index} draggableId={index.toString()} index={index}>
                        {(provided) => {
                          return (
                            <div
                              className="w-fit"
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{ ...provided.draggableProps.style }}>
                              {option}
                            </div>
                          );
                        }}
                      </Draggable>
                    ))}
                  </div>

                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
        {/* input and placeholder */}
        <div className="flex items-center ">
          {selectedOptions.length ? children?.[1] : [...children].reverse()}
        </div>
      </div>
    </components.ValueContainer>
  );
};
